import { Cancel, Delete } from "@mui/icons-material";
import { Box, Modal, Typography,ButtonGroup, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import deleteRequestinterface from "../interface/deleteRequestinterface";
import getReq from "../interface/getRequestinterface";
import { deleteRequest, getRequest } from "../request";

const style = {
    modal:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
    },
    btnGroup:{
      width:"100%",
      position:'relative',
      display:'flex',
      justifyContent:'flex-end',
      marginTop:'3rem'
    },
    deleteBtn:{
      color:'#fff',
      backgroundColor:'#D61C4E',
      '&:hover':{
        backgroundColor:'#99191e',
        
      }
    },
    returnBtn:{
      color:'#fff',
      backgroundColor:'#262626',
      '&:hover':{
        backgroundColor:'#1e1e1e',
        
      }
    }
  };

function DeleteModal({openDeleteModal,setOpenDeleteModal,parameterName,deleteURL,destination,setIsSuccessful}) {
    const navigate = useNavigate();
    const handleDelete=async()=>{
      const data :deleteRequestinterface = await deleteRequest(deleteURL) as deleteRequestinterface
      if(data.status === 200){
        toast.success('حذف با موفقیت انجام شد!');
        setIsSuccessful(true);
        if(destination){
          navigate(destination);
        }else{
          window.location.reload();
        }
      }else{
        toast.error('عملیات حذف ناموفق بود!');
      }
    }
    const handleClose = ()=>{
      setOpenDeleteModal(false);
    }
  return (
    <div>
      <Modal
        open={openDeleteModal}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style.modal}>
          <Typography  variant="h6" component="h2">
          آیا مطمئن هستید که  می خواهید  {parameterName} را حذف کنید؟
          </Typography>
          <Box sx={style.btnGroup}>
            <ButtonGroup size="small" sx={{direction:'ltr'}}>
              <Button variant="contained" size="small"  onClick={handleDelete} sx={style.deleteBtn}>
                حذف <Delete/>
              </Button>
              <Button variant="contained" size="small"  onClick={handleClose} sx={style.returnBtn}>
                بازگشت <Cancel/>
              </Button>
            </ButtonGroup>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default DeleteModal;
